export enum VideoTuneEnum {
  Film = 0,
  Animation = 1,
  Grain = 2,
  StillImage = 3,
  PeakSignalToNoiseRatio = 4, // (PSNR)
  StructuralSimilarityIndexMeasure = 5, // (Ssim)
  FastDecode = 6,
  Zerolatency = 7,
}

export type VideoTune =
  | VideoTuneEnum.Film
  | VideoTuneEnum.Animation
  | VideoTuneEnum.Grain
  | VideoTuneEnum.StillImage
  | VideoTuneEnum.PeakSignalToNoiseRatio
  | VideoTuneEnum.StructuralSimilarityIndexMeasure
  | VideoTuneEnum.FastDecode
  | VideoTuneEnum.Zerolatency;
